// extracted by mini-css-extract-plugin
export default {"list":"list-rt1n"};